// src/services/api.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'src/config';
import { addExpiryTimeRange } from 'src/utils/utils';
import { clearCredentials, setCredentials } from 'src/configuration/tokenHandling/authSlice';

const BASE = config.backend.ACCESS_TOKEN_SERVICE;
const PATH = config.backend.ACCESS_TOKEN_PATH;
const baseQuery = fetchBaseQuery({
    baseUrl: BASE,
    prepareHeaders: (headers) => {
        // const token = getEEAdminAccessToken();
        // const token = 'abc';
        // if (token) {
        //     headers.set('Authorization', `Bearer ${token}`);
        // }
        // return headers;
    },
    // credentials: 'include', // in case backend relies on cookies
});

// wrapper that tries refresh if 401 is encountered
const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    if (result.data) {
        const { access_token, expires_in } = result.data;
        const expiresAt = addExpiryTimeRange(expires_in); // Date.now() + expires_in * 1000;
        // store new token in redux
        api.dispatch(setCredentials({ accessToken: access_token, expiresAt }));
    }

    if (result.error && result.error.status === 401) {
        // try to refresh
        try {
            const refreshResult = await baseQuery({ url: PATH, method: 'GET' }, api, extraOptions);
            if (refreshResult.data) {
                // response { access_token, expires_in }
                const { access_token, expires_in } = refreshResult.data;
                const expiresAt = addExpiryTimeRange(expires_in); //Date.now() + expires_in * 1000;
                // store new token in redux
                api.dispatch(setCredentials({ accessToken: access_token, expiresAt }));
                // retry original request
                result = await baseQuery(args, api, extraOptions);
            } else {
                // couldn't refresh - clear credentials and return original error
                api.dispatch(clearCredentials());
            }
        } catch (e) {
            // If refresh fails, clear credentials
            api.dispatch(clearCredentials());
        }
    }

    return result;
};

export const authApi = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['AccessToken'],
    endpoints: (builder) => ({
        // GET endpoint for access token
        getProtected: builder.query({
            query: () => ({ url: PATH, method: 'GET' }),
            providesTags: ['AccessToken'],
        }),
    }),
});

export const { useGetProtectedQuery } = authApi;
